export const SYNC_ACTIVITIES_CHANNEL = '@@activitiesChannel/sync'
export const SYNC_SENT_ACTIVITIES_CHANNEL = '@@activitiesChannel/syncSent'
export const SYNC_CANCEL_ACTIVITIES_CHANNEL = '@@activitiesChannel/syncCancelled'

export const UPDATE_ACTIVITIES_CHANNEL = '@@activitiesChannel/update'
export const CLEAR_ACTIVITIES_CHANNEL = '@@activitiesChannel/clear'

export const OPEN_ACTIVITIES_CHANNEL = '@@activitiesChannel/open'
export const CLOSE_ACTIVITIES_CHANNEL = '@@activitiesChannel/close'
